import React from 'react';
import Message from 'components/parts/message';

const Start = ()  => {
  return (
    <div className="col-10 pt-3 pb-3">
      <Message />
    </div>
  );
};

export default Start;
